.tagCard {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-decoration: none;

  .tagCardIcon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--primitives-colors-neutral-970);
  }

  .tagCardInfo {
    display: flex;
    flex-direction: column;
  }

  .tagName {
    font: var(--font-body-md-medium);
    line-height: 25px;
    color: var(--primitives-colors-neutral-0);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 220px;

    .phone &,
    .tablet & {
      max-width: 170px;
    }
  }

  .tagQty {
    width: 100%;
    text-transform: uppercase;
    font: var(--font-body-sm-regular);
    line-height: 22px;
    color: var(--semantic-colors-typography-faded);
    display: block;
    margin-top: 2px;
  }
}